import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const InteractiveChartWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const BodyLoader = styled(ContentLoader)`
  background-color: ${({ theme }) => theme.colors.text.interactive};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  height: 100%;
  width: 100%;
`;

export const Chart = styled.rect`
  height: 100%;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.medium};
`;
